export default __webpack_public_path__ + "static/media/na-mini.820245af.png";